import React, { createContext, useContext, useState, ReactNode } from 'react'

interface Staff {
  fullName: string
  nickname?: string
  role: string
  id: string
}

interface StaffInfo {
  id: string
  fullName: string
  nickname: string
  role: string
  phone: string
  email: string
  department: string
  store: string
  joinDate: string
  avatar?: string
}

interface StaffContextType {
  staff: Staff | null
  staffInfo: StaffInfo
  updateStaffInfo: (info: Partial<StaffInfo>) => void
  logout: () => void
}

const defaultStaffInfo: StaffInfo = {
  id: '1',
  fullName: 'Ngọc Lan',
  nickname: 'Lan',
  role: 'Nhân viên bán hàng',
  phone: '0909090909',
  email: 'ngoclan@gmail.com',
  department: 'Sales',
  store: 'CH Quận 3',
  joinDate: '2024-01-01'
}

const StaffContext = createContext<StaffContextType>({
  staff: {
    id: '1',
    fullName: 'Ngọc Lan',
    nickname: 'Lan',
    role: 'Nhân viên bán hàng'
  },
  staffInfo: defaultStaffInfo,
  updateStaffInfo: () => {},
  logout: () => {}
})

export const StaffProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [staffInfo, setStaffInfo] = useState<StaffInfo>(defaultStaffInfo)

  const updateStaffInfo = (info: Partial<StaffInfo>) => {
    setStaffInfo(prev => ({
      ...prev,
      ...info
    }))
  }

  const logout = () => {
    // Reset staff info to default or empty state when logging out
    setStaffInfo(defaultStaffInfo)
  }

  return (
    <StaffContext.Provider value={{
      staff: {
        id: '1',
        fullName: 'Ngọc Lan',
        nickname: 'Lan',
        role: 'Nhân viên bán hàng'
      },
      staffInfo,
      updateStaffInfo,
      logout
    }}>
      {children}
    </StaffContext.Provider>
  )
}

export const useStaff = () => {
  const context = useContext(StaffContext)
  if (context === undefined) {
    throw new Error('useStaff must be used within a StaffProvider')
  }
  return context
}

export default StaffProvider 